import { BATTLE_KEY } from "~/components/BossBattle/composables/initMainView";
import { EVENT_KEY } from "~/stores/exchanger";
import { EVENT_NAME } from "~/stores/exchanger";

export const useBannersStore = defineStore("bannersStore", () => {
  const platform = usePlatform();

  const bannerTelegram = {
    promo: "home.banner.banner_promo_community",
    title: "home.banner.telegram_bonuses",
    text: "home.banner.telegram_bonuses_text",
    btn: "Telegram",
    link: platform.tg,
    gradientDesktop:
      "radial-gradient(182.97% 218.97% at 52.71% 176.52%, #3D2C62 0%, #12111C 100%)",
    gradientTablet:
      "radial-gradient(182.97% 218.97% at 52.71% 176.52%, #3D2C62 0%, #12111C 100%)",
    gradientMobile:
      "radial-gradient(77.25% 78.73% at 50% -37.66%, rgba(126, 124, 202, 0.10) 0%, rgba(125, 125, 202, 0.00) 100%), radial-gradient(94.74% 59.65% at 50% -4.05%, rgba(255, 81, 121, 0.10) 0%, rgba(255, 128, 157, 0.00) 100%), radial-gradient(450.67% 460.62% at -56.51% -389.76%, #FF5179 0%, rgba(255, 128, 157, 0.00) 100%), radial-gradient(182.97% 218.97% at 52.71% 176.52%, #3D2C62 0%, #12111C 100%)",
    imgDesk: "/banners/telegram-desk.png",
    imgTablet: "/banners/telegram-tablet.png",
    imgMobile: "/banners/telegram-mobile.png",
  };
  const bannerMegalodon = {
    promo: "home.banner.banner_promo_event",
    title: `${BATTLE_KEY}.banner.title`,
    text: `${BATTLE_KEY}.banner.content`,
    btn: `${BATTLE_KEY}.banner.attack`,
    link: "/boss-battle",
    gradientDesktop:
      "radial-gradient(193.47% 208.62% at 28.48% -59.91%, #259EB9 0%, #031633 100%)",
    gradientTablet:
      "radial-gradient(193.47% 208.62% at 28.48% -59.91%, #259EB9 0%, #031633 100%)",
    gradientMobile:
      "radial-gradient(164.05% 165.51% at -16.63% -31.9%, #259EB9 0%, #031633 100%)",
    imgDesk: "/banners/megalodon-desk.png",
    imgTablet: "/banners/megalodon-tablet.png",
    imgMobile: "/banners/megalodon-mobile.png",
  };
  const bannerPromo = {
    promo: "home.banner.banner_promo_promocode",
    title: "home.banner.topup_bonus",
    text: "home.banner.topup_bonus_text",
    btn: "home.banner.topup_now",
    link: "/balance/top-up",
    gradientDesktop:
      "radial-gradient(ellipse 78.06% 120.82% at 67.41% 88.06%, #ffe41a 0, #f1823c 35%, #e5492e 69%, #731767)",
    gradientTablet:
      "radial-gradient(119.9% 78.62% at 67.41% 88.06%, #FFE41A 0%, #F1823C 35.5%, #E5492E 68.5%, #731767 100%)",
    gradientMobile:
      "radial-gradient(94.04% 95% at 50% 106.55%, #FFE41A 0%, #F1823C 35.5%, #E5492E 68.5%, #731767 100%)",
    imgDesk: "/banners/promo-desk.png",
    imgTablet: "/banners/promo-tablet.png",
    imgMobile: "/banners/promo-mobile.png",
  };
  const bannerBullpass = {
    promo: "home.banner.banner_promo_bullpass",
    title: "home.banner.bullpass_summer",
    text: "home.banner.bullpass_summer_text",
    btn: "home.banner.to_tasks",
    link: "/event",
    gradientDesktop:
      "radial-gradient(237.68% 247.86% at 100% 199.53%, #00FFEA 0%, #283394 100%)",
    gradientTablet:
      "radial-gradient(308.18% 427.41% at 107.78% 341.79%, #00F0FF 0%, #283394 100%)",
    gradientMobile:
      "radial-gradient(191.51% 191.42% at 140.93% -29.17%, #00F0FF 0%, #283394 88.96%)",
    imgDesk: "/banners/bullpass-desk.png",
    imgTablet: "/banners/bullpass-tablet.png",
    imgMobile: "/banners/bullpass-mobile.png",
  };
  const bannerUpgrade = {
    promo: "home.banner.banner_promo_mini_games",
    title: "home.banner.upgrade",
    text: "home.banner.upgrade_text",
    btn: "home.banner.upgrade_play",
    link: "/games/upgrade",
    gradientDesktop:
      "radial-gradient(89.1% 220.81% at 81.44% 156.78%, #6E7BD8 0%, #161C3B 100%)",
    gradientTablet:
      "radial-gradient(89.1% 220.81% at 81.44% 156.78%, #6E7BD8 0%, #161C3B 100%)",
    gradientMobile:
      "radial-gradient(89.1% 220.81% at 81.44% 156.78%, #6E7BD8 0%, #161C3B 100%)",
    imgDesk: "/banners/upgrade-desk.png",
    imgTablet: "/banners/upgrade-tablet.png",
    imgMobile: "/banners/upgrade-mobile.png",
  };
  const bannerContracts = {
    promo: "home.banner.banner_promo_mini_games",
    title: "home.banner.contracts",
    text: "home.banner.contracts_text",
    btn: "home.banner.create_contract",
    link: "/games/contracts",
    gradientDesktop:
      "radial-gradient(397.86% 822.1% at 81.19% 409.15%, #FF595F 29.36%, #181822 56.23%, #1D1D25 100%)",
    gradientTablet:
      "radial-gradient(397.86% 822.1% at 81.19% 409.15%, #FF595F 29.36%, #181822 56.23%, #1D1D25 100%)",
    gradientMobile:
      "radial-gradient(397.86% 822.1% at 81.19% 409.15%, #FF595F 29.36%, #181822 56.23%, #1D1D25 100%)",
    imgDesk: "/banners/contracts-desk.png",
    imgTablet: "/banners/contracts-tablet.png",
    imgMobile: "/banners/contracts-mobile.png",
  };
  const bannerElfsFactory = {
    promo: "home.banner.banner_promo_event",
    title: `${EVENT_KEY}.banner.title`,
    text: `${EVENT_KEY}.banner.${platform.code}_content`,
    btn: `${EVENT_KEY}.banner.play`,
    link: `/${EVENT_NAME}`,
    gradientDesktop:
      "radial-gradient(1261.65% 122.13% at -1.16% -3.05%, #FC7D89 0%, #9F3D50 27.6%, #312D3E 66.15%, #272432 100%)",
    gradientTablet:
      "radial-gradient(1261.65% 122.13% at -1.16% -3.05%, #FC7D89 0%, #9F3D50 27.6%, #312D3E 66.15%, #272432 100%)",
    gradientMobile:
      "radial-gradient(154.86% 135.28% at -1.16% -3.05%, #FC7D89 0%, #9F3D50 27.6%, #312D3E 66.15%, #272432 100%)",
    imgDesk: "/banners/elf-factory-desc.png",
    imgTablet: "/banners/elf-factory-tablet.png",
    imgMobile: "/banners/elf-factory-mobile.png",
  };
  const bannerInfo = {
    promo: "home.banner.banner_promo_promocode",
    title: "home.banner.topup_bonus",
    text: "home.banner.topup_bonus_text",
    btn: "home.banner.topup_now",
    link: "/balance/top-up",
    gradientDesktop:
      "radial-gradient(567.43% 166.47% at 27.59% -53.12%, #252933 28.32%, #E58340 88.31%, #F3C177 100%)",
    gradientTablet:
      "radial-gradient(990.94% 183.06% at 27.59% -53.13%, #252933 28.32%, #E58340 75.93%, #F3C177 91.07%)",
    gradientMobile:
      "radial-gradient(189.73% 191.72% at 86.98% -42.74%, #F3C177 8.93%, #E58340 24.07%, #252933 71.68%)",
    imgDesk: "/banners/pubg-desk.png",
    imgTablet: "/banners/pubg-tablet.png",
    imgMobile: "/banners/pubg-mobile.png",
  };
  const bannerPoseidon = {
    promo: "home.banner.banner_promo_event",
    title: `${EVENT_KEY}.banner.title`,
    text: `${EVENT_KEY}.banner.${platform.code}_content`,
    btn: `${EVENT_KEY}.banner.play`,
    link: `/${EVENT_NAME}`,
    gradientDesktop:
      "radial-gradient(193.47% 208.62% at 28.48% -59.91%, #259EB9 0%, #031633 100%)",
    gradientTablet:
      "radial-gradient(193.47% 208.62% at 28.48% -59.91%, #259EB9 0%, #031633 100%)",
    gradientMobile:
      "radial-gradient(164.05% 165.51% at -16.63% -31.9%, #259EB9 0%, #031633 100%)",
    imgDesk: "/banners/poseidon-desk.png",
    imgTablet: "/banners/poseidon-tablet.png",
    imgMobile: "/banners/poseidon-mobile.png",
  };

  return {
    bannerTelegram,
    bannerMegalodon,
    bannerInfo,
    bannerPromo,
    bannerUpgrade,
    bannerContracts,
    bannerElfsFactory,
    bannerBullpass,
    bannerPoseidon,
  };
});
